import { AgentRuntimeProviderIdEnum } from './providers';
export const DEFAULT_CLAUDE_WORKSPACE_ID = 'default';
const CLAUDE_PLATFORM_CONSOLE_PROVIDER_IDS = new Set([
    AgentRuntimeProviderIdEnum.Anthropic,
    AgentRuntimeProviderIdEnum.NovuAnthropic,
    AgentRuntimeProviderIdEnum.AnthropicAws,
]);
export function isAnthropicAwsProvider(providerId) {
    return providerId === AgentRuntimeProviderIdEnum.AnthropicAws;
}
export function isClaudePlatformConsoleProvider(providerId) {
    return CLAUDE_PLATFORM_CONSOLE_PROVIDER_IDS.has(providerId);
}
export function buildClaudePlatformAgentConsoleUrl(externalAgentId, externalWorkspaceId) {
    const workspaceId = encodeURIComponent(externalWorkspaceId?.trim() || DEFAULT_CLAUDE_WORKSPACE_ID);
    return `https://platform.claude.com/workspaces/${workspaceId}/agents/${encodeURIComponent(externalAgentId)}`;
}
//# sourceMappingURL=anthropic-aws.js.map